export default "/assets/images/housekeeping-service.webm?29b578ade2a1b98e7bd824549d31a093";